export default function hasActiveFacet(facets: any) {
  for (const groupKey in facets) {
    if (Object.prototype.hasOwnProperty.call(facets, groupKey)) {
      const facetGroup = facets[groupKey]
      const facetAttributes = facetGroup.facetAttributes

      for (const attributeKey in facetAttributes) {
        if (
          Object.prototype.hasOwnProperty.call(facetAttributes, attributeKey)
        ) {
          const attribute = facetAttributes[attributeKey]
          if (attribute.isActive === true) {
            return true // At least one active facet found
          }
        }
      }
    }
  }
  return false // No active facets found
}
